<div
  layout="row"
  layout-margin
>
  <div
    flex="30"
    flex-sm="100"
  >
    <form
      [formGroup]="formSettings"
      (submit)="submitForm()"
      method="post"
    >
      <div style="margin: 20px">
        <h1>Parâmetros</h1>
        <div class="row">
          <h2>Painel</h2>
          <div>
            <mat-form-field>
              <mat-label>Falar nome do paciente</mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="SPEECH_NAME_PANEL"
              >
                <mat-option value="true">Sim</mat-option>
                <mat-option value="false">Não</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Falar texto antes do nome</mat-label>
              <input
                formControlName="SPEECH_PREV_PANEL"
                matInput
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Falar nome do local ou guichê</mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="SPEECH_LOCAL_ROOM"
              >
                <mat-option value="true">Sim</mat-option>
                <mat-option value="false">Não</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Dimensão da senha/anúncio </mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="TOTEM_DIMENSAO"
              >
                <mat-option value="auto">Expansão automática</mat-option>
                <mat-option value="fixo">Fixo 50% / 50%</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label> Histórico de chamados </mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="TOTEM_HISTORY"
              >
                <mat-option value="true">Sim</mat-option>
                <mat-option value="false">Não</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label> Usar paineis </mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="TOTEM_USEPANELS"
              >
                <mat-option value="true">Sim</mat-option>
                <mat-option value="false">Não</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Usar local no Painel</mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="USAR_LOCAL"
              >
                <mat-option value="Sim">Sim</mat-option>
                <mat-option value="Nao">Não</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <h2>Totem</h2>
          <div class="row">
            <mat-form-field>
              <mat-label>Opção de atendimento prioritário</mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="PRIORITY"
              >
                <mat-option value="true">Sim</mat-option>
                <mat-option value="false">Não</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Data de Nascimento, buscar por</mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="TOTEM_CALENDAR"
              >
                <mat-option value="both">Ambos</mat-option>
                <mat-option value="calendar">Calendário</mat-option>
                <mat-option value="input">Input</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Impressão térmica</mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="TOTEM_PRINTER"
              >
                <mat-option value="true">Sim</mat-option>
                <mat-option value="false">Não</mat-option>
              </mat-select>
            </mat-form-field>
            <button
              mat-button
              color="primary"
              type="button"
              (click)="testPrint()"
            >
              Teste local
            </button>
            <mat-form-field>
              <mat-label>Pular atualização de cadastro do paciente</mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="TOTEM_SKIP_PATIENT_DATA"
              >
                <mat-option value="true">Sim</mat-option>
                <mat-option value="false">Não</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-8 mx-auto mt-5">
        <div style="margin: 30px">
          <button
            [disabled]="showSpinner ? true : false"
            class="mt-3"
            type="submit"
            mat-raised-button
            color="primary"
          >
            <mat-spinner
              diameter="18"
              [style.display]="showSpinner ? 'inline-block' : 'none'"
            >
            </mat-spinner
            >Atualizar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
